import { Search, ShareOutlined} from "@mui/icons-material";
import { GridLegacy as Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import {  InputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DialogType } from "../../utils/constants";
import ModalFichaTecnica from "../../components/form/Modal-ficha-tecnica";
import FeedIcon from '@mui/icons-material/Feed';



const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MisProductosAsociados = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [fichaTecnica,setFichaTecnica] = useState([]);
  const [isVisibleFichaTecnica,setIsVisibleFichaTecnica] = useState(false);



    useEffect(()=>{

      loadProducts();


    },[]);

    useEffect(()=>{
  
      loadProducts( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);
    const loadProducts =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/get-productos-asociados",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      console.log({InitialFilterSearch});
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }


    const openModalFichaTecnica = (cod_prod)=>{
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      console.log(product.ficha_tecnica);
      setFichaTecnica({
        fichaTecnica:product.ficha_tecnica,
        cod_producto:cod_prod
      });
      setIsVisibleFichaTecnica(true); 
    }  

    const compartirFichaTecnica = (cod_producto)=>{
      console.log({
        cod_producto,
        cod_usuario:profile.cod
      });
      const urlshare = `${import.meta.env.VITE_CUSTOM_URL}ficha-tecnica/${btoa(String(cod_producto))}/${btoa(String(profile.cod))}`;
      dispatch({
        type:ActionTypes.setModalInfo,
        data:{
            title:"Compartir ficha tecnica",
            message:"<a href='"+urlshare+"' >"+urlshare+"</a>",
            type:DialogType.peligro,
            isVisible:true
        }
    });
    }
  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"CODIGO ERP",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"descripcion",
        keyValue:"descripcion",
        label:"Nombre",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"nombre_unidad_medida",
        keyValue:"nombre_unidad_medida",
        label:"Unidad de medida",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"porcentaje_sobrecompra",
        keyValue:"porcentaje_sobrecompra",
        label:"% Sobrecompra",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"ver-ficha-tecnica",
        keyValue:"cod",
        label:"Ficha tecnica",
        headerRender:(props)=>props.label,
        bodyRender:({value})=>
         <Stack direction={"row"} >
            <IconButton size="small" onClick={e=>compartirFichaTecnica(value)}  color="primary" aria-label="Compartir ficha técnica"  ><ShareOutlined/></IconButton> 
            <IconButton size="small" color="primary" onClick={e=>openModalFichaTecnica(value)} aria-label="Ver ficha técnica"  ><FeedIcon/></IconButton>
         </Stack>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
      //  {
      
      //   key:"ver-detalle",
      //   keyValue:"cod",
      //   label:"Ver detalle",
      //   headerRender:(props)=>props.label,
      //   bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<VisibilityRounded/>} >Ver</Button>,
      //   typeRow:"number",
      //   sort:false,
      //   sortFunction:()=>{},
      //   sortStatus:"", 
 
      //  },  
    ];

    return (<>
   
   <ModalFichaTecnica  
  dispatch={dispatch}
  setIsVisibleFichaTecnica={setIsVisibleFichaTecnica} 
  isOpen={isVisibleFichaTecnica} 
  dataFichaTecnica={fichaTecnica} 
  updateProdList = {loadProducts}
  />
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar producto"
              inputType="text"
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}